import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  title = input('Not found');
  description = input('Not found');
  iconSrc = input<string | undefined>(undefined);
  hasConfirmButton = input(false);
  confirmButtonText = input('Confirm');
  hasCancelButton = input(false);
  cancelButtonText = input('Cancel');

  buttonAction = output<'confirm' | 'cancel'>();

  onButtonClick(action: 'confirm' | 'cancel'): void {
    this.buttonAction.emit(action);
  }
}
